<input
  type="time"
  inputTime
  step="60"
  [name]="props.name"
  [required]="!!props.required"
  [readonly]="props.readonly"
  [formControl]="formControl"
  [formlyAttributes]="field"
  matInput
/>
